















import Vue from "vue";
import {
  RootState,
  SET_QUESTIONNAIRE_STEP,
  SET_QUESTIONNAIRE_ERROR,
  GET_ANSWER_BY_ID
} from "@/store/types";
import { mapMutations, mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "Nav",

  components: {},

  computed: {
    ...mapGetters({
      getAnswerById: GET_ANSWER_BY_ID
    }),
    ...mapState({
      currentStep: state => (state as RootState).currentQuestionnaireStep,
      steps: state => (state as RootState).questionnaireSteps,
      userData: state => (state as RootState).userData
    }),

    stepObj(): Record<string, any> {
      return this.steps.find(step => step.order === this.currentStep);
    }
  },

  methods: {
    ...mapMutations({
      setCurrentStep: SET_QUESTIONNAIRE_STEP,
      setError: SET_QUESTIONNAIRE_ERROR
    }),

    goBack(): void {
      this.setError(null);
      this.setCurrentStep(this.currentStep - 1);
    },

    goForward() {
      if (this.validateStep()) {
        this.setCurrentStep(this.currentStep + 1);
      }
    },

    validateStep(): boolean {
      this.setError(null);

      if (this.stepObj.component === "AddressData") {
        if (
          !this.$store.state.survey.disableUserInput &&
          !this.userData.selectedPlace.location.lat &&
          !this.userData.selectedPlace.location.lng
        ) {
          this.setError("Proszę zaznaczyć lokalizację na mapie.");
          return false;
        }
      } else if (this.stepObj.component === "Question") {
        const question = this.stepObj.question;
        const answer = this.getAnswerById(question.id);

        if (question.isOpen) {
          if (!answer || answer.openAnswer.length < 10) {
            this.setError("Odpowiedź musi się składać z minimum 10 znaków.");
            return false;
          }
        } else {
          if (!answer || answer.answers.length === 0) {
            this.setError("Proszę zaznaczyć przynajmniej jedną odpowiedź.");
            return false;
          }
        }
      }

      return true;
    }
  }
});
